import Icon from "~/components/ui/Icon"
import type { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"

export interface Link {
    /**
     * @title Texto
     */
    label: string
    /**
     * @title Link
     */
    href: string
}

/**
 * @titleBy label
 */
export interface Social {
    /**
     * @title Rede social
     */
    label: 'Instagram' | 'Facebook'
    /**
     * @title Link
     */
    href: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string
    /**
     * @title Descrição
     */
    description?: string
    /**
     * @title Links
     */
    links?: Link[]
    /**
     * @title Imagem de fundo
     */
    bgImage?: ImageWidget
    /**
     * @title Avatar
     */
    avatar?: ImageWidget
    /**
     * @title Redes sociais
     */
    social?: Social[]
}

function LinkTree({ bgImage, avatar, title = '', description = '', links, social }: Props) {
    return (
        <div
            className='flex flex-col justify-start items-center gap-10 bg-base-content p-10 h-screen overflow-y-hidden'
            style={bgImage ? { background: `url(${bgImage})` } : undefined}
        >
            <header className='flex flex-col justify-center items-center gap-4'>
                <div className='rounded-full w-min bg-base-100 p-4'>
                    {avatar && <Image src={avatar} width={150} height={150} loading='lazy' />}
                </div>
                <span className='font-medium text-xl text-base-100'>{title}</span>
                <span className='text-base-100'>{description}</span>
            </header>
            <main className='w-full max-w-[80%] sm:max-w-[50%]'>
                <ul className='flex flex-col justify-center items-center gap-4'>
                    {links?.map((link) => (
                        <li className='w-full'>
                            <a
                                href={link.href}
                                className='text-base-100 rounded-3xl text-center w-full flex justify-center items-center min-h-[36px] hover:bg-base-100 hover:text-base-content border border-base-100'
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </main>
            <footer>
                <ul className='flex flex-row gap-4'>
                    {social?.map((link) => (
                        <li>
                            <a
                                href={link.href}
                                className='text-base-100 block rounded-full hover:text-base-content hover:bg-base-100 p-2'
                            >
                                <Icon id={link.label} size={36} strokeWidth={0.8} />
                            </a>
                        </li>
                    ))}
                </ul>
            </footer>
        </div>
    )
}

export default LinkTree
